(function () {
  'use strict';

  // ===== SCROLL PROGRESS =====
  var scrollEl = document.getElementById('ap-scroll-progress');
  var scrollThrottle = 0;
  if (scrollEl) {
    window.addEventListener('scroll', function () {
      var now = Date.now();
      if (now - scrollThrottle < 16) return;
      scrollThrottle = now;
      var scrolled = window.scrollY || document.documentElement.scrollTop;
      var total = document.documentElement.scrollHeight - window.innerHeight;
      if (total > 0) scrollEl.style.width = Math.min(100, (scrolled / total) * 100) + '%';
    }, { passive: true });
  }

  // ===== STOCK BAR =====
  var stockBar = document.getElementById('ap-stock-bar');
  var stockPct = document.getElementById('ap-stock-pct');
  if (stockBar && 'IntersectionObserver' in window) {
    var sbTarget   = parseFloat(stockBar.dataset.target || '73');
    var reducedMot = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }
    var sbIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        sbIO.unobserve(e.target);
        if (reducedMot) {
          stockBar.style.width = sbTarget + '%';
          if (stockPct) stockPct.textContent = Math.round(sbTarget) + '%';
          setTimeout(function () { stockBar.classList.add('pulsing'); }, 400);
          return;
        }
        var duration = 1200;
        var start    = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased    = easeOutQuart(progress);
          var val      = eased * sbTarget;
          stockBar.style.width = val + '%';
          if (stockPct) stockPct.textContent = Math.round(val) + '%';
          if (progress < 1) { requestAnimationFrame(step); }
          else { setTimeout(function () { stockBar.classList.add('pulsing'); }, 800); }
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.3 });
    sbIO.observe(stockBar);
  }

  // ===== STOCK FLUCTUATION =====
  var stockKey = 'aorami_stock_' + new Date().toISOString().slice(0, 10);
  var stockNum = parseInt(localStorage.getItem(stockKey) || '23', 10);
  if (!localStorage.getItem(stockKey)) localStorage.setItem(stockKey, stockNum);

  function updateStock() {
    if (stockNum > 7) {
      stockNum -= 1;
      localStorage.setItem(stockKey, stockNum);
      var el = document.getElementById('ap-stock-num');
      if (el) el.textContent = stockNum + ' piezas';
    }
    setTimeout(updateStock, 45000 + Math.random() * 45000);
  }
  setTimeout(updateStock, 60000);

  // ===== COUNTDOWN =====
  var SECS_TOTAL = 10 * 60;
  var cdKey = 'aorami_end_' + new Date().toISOString().slice(0, 10);
  var cdEnd = parseInt(localStorage.getItem(cdKey) || '0', 10);
  if (!cdEnd || cdEnd < Date.now()) {
    cdEnd = Date.now() + SECS_TOTAL * 1000;
    localStorage.setItem(cdKey, cdEnd);
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function tick() {
    var rem = Math.max(0, Math.floor((cdEnd - Date.now()) / 1000));
    var h = Math.floor(rem / 3600);
    var m = Math.floor((rem % 3600) / 60);
    var s = rem % 60;
    var eh = document.getElementById('ap-hours');
    var em = document.getElementById('ap-mins');
    var es = document.getElementById('ap-secs');
    if (eh) eh.textContent = pad(h);
    if (em) em.textContent = pad(m);
    if (es) es.textContent = pad(s);
    if (rem > 0) setTimeout(tick, 1000);
  }
  tick();


  // ===== PILLS EXPAND =====
  var pillsBtn = document.getElementById('ap-pills-btn');
  if (pillsBtn) {
    pillsBtn.addEventListener('click', function () {
      ['ap-pill-4', 'ap-pill-5', 'ap-pill-6'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) { el.classList.add('expanded'); el.style.display = 'inline-flex'; }
      });
      var more = document.getElementById('ap-pills-more');
      if (more) more.style.display = 'none';
    });
  }

  // ===== COMP EXPAND =====
  var compBtn = document.getElementById('ap-comp-expand');
  if (compBtn) {
    compBtn.addEventListener('click', function () {
      ['ap-comp-2', 'ap-comp-3'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.style.display = 'block';
      });
      compBtn.style.display = 'none';
    });
  }

  // ===== FAQ =====
  document.querySelectorAll('.ap .faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.ap .faq-item.open').forEach(function (el) {
        el.classList.remove('open');
        el.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ===== BUY NOW — scroll to CTA final =====
  ['ap-btn-buy-hero', 'ap-btn-buy'].forEach(function (id) {
    var b = document.getElementById(id);
    if (b) b.addEventListener('click', function () {
      var target = document.getElementById('comprar-final');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  });

  var root = document.getElementById('ap-root');
  if (root) root.classList.add('js-ready');

})();
